// Toggle in the customer config/<customer>.env.js file.
export const isFixedWorkflowCatalog = process.env.WORKFLOW_FIXED_CATALOG === true;

export function isWorkflowCatalogRestricted(user) {
    const isRootAdmin = user && Array.isArray(user.roles)
        && user.roles.some(role => role && role.name === 'ROOT_ADMIN');
    return isFixedWorkflowCatalog && !isRootAdmin;
}
